// extracted by mini-css-extract-plugin
export default {"profile-div":"profile_profile-div__NcAiS"};